<template>
  <v-container id="page-notice-detail">
    <div class="page-title mb-5">{{ this.pageTitle }}</div>
    <c-card>
      <v-form lazy-validation ref="form">
        <v-row align="center">
          <span class="mx-2">제목</span>
          <v-checkbox
            label="중요"
            v-model="criticalFlag"
            class="mr-3" dense>
          </v-checkbox>
          <v-col>
            <v-text-field v-model="noticeTitle" placeholder="제목을 입력해주세요." solo dense required
                          :rules="[v => !!v]"
                          hide-details :autofocus="true" color="navy" maxlength="1024"></v-text-field>
          </v-col>
        </v-row>
        <ckeditor v-model="noticeContents" :config="editorConfig" tag-name="textarea"></ckeditor>
      </v-form>
    </c-card>
    <v-row justify="start" class="mt-3 ml-2">
      <c-btn v-if="id" color="blue" outlined class="mr-1" iconName="edit" @click="onUpdateNotice()" :loading="loading">수정</c-btn>
      <c-btn v-else color="blue" outlined class="mr-1" iconName="check" @click="onAddNotice()" :loading="loading">등록</c-btn>
      <c-btn color="blue" outlined iconName="mdi-close" @click="$router.go(-1)" :loading="loading">취소</c-btn>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      pageTitle: '공지사항 작성',

      id: '',
      noticeTitle: '',
      noticeContents: '',
      criticalFlag: false,

      editorConfig: {
        language: 'ko',
        height: 500,
        autoGrow_onStartup: true,
      },
      loading: false,
    }),
    mounted() {
      const {noticeId} = this.$route.params;
      if (noticeId) {
        this.id = noticeId;
        this.reqNotice(noticeId);
        this.pageTitle = '공지사항 수정';
      }
    },
    methods: {
      async reqNotice(id) {
        try {
          const res = await this.$api.getNotice(id);

          const noticeData = res.data;
          this.noticeTitle = noticeData.noticeTitle;
          this.noticeContents = noticeData.noticeContents;
          this.criticalFlag = noticeData.criticalFlag !== "F";
          this.id = noticeData.id;

        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqNotice'});
        }
      },
      onAddNotice() {
        if (!this.noticeContents || !this.noticeTitle) {
          this.$store.commit('snackbar', {timeout: 2000, msg: '비어있는 필드가 있습니다.'});
          return;
        }

        let reqParam = {
          creatorId : this.$store.state.userInfo.loginId,
          noticeContents : this.noticeContents,
          noticeTitle : this.noticeTitle,
          criticalFlag : this.criticalFlag
        };
        this.reqAddNotice(reqParam);
      },
      onUpdateNotice() {
        if (!this.noticeContents || !this.noticeTitle) {
          this.$store.commit('snackbar', {timeout: 2000, msg: '비어있는 필드가 있습니다.'});
          return;
        }

        let reqParam = {
          id : this.id,
          noticeContents: this.noticeContents,
          noticeTitle : this.noticeTitle,
          criticalFlag : this.criticalFlag
        };
        this.reqUpdateNotice(reqParam);

      },
      onDeleteNotice() {
        this.$emit('reqDeleteNotice', this.noticeInfo.id);
      },
      async reqAddNotice(data) {
        this.loading = true
        try {
          const res = await this.$api.addNotice(data);
          await this.$router.push(`/noticeboard`);
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqAddVehicle'});
        } finally {
          this.loading = false
        }
      },
      async reqUpdateNotice(data) {
        this.loading = true
        try {
          const res = await this.$api.updateNotice(data);
          await this.$router.push(`/noticeboard/${this.id}`);
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqUpdateVehicle'});
        } finally {
          this.loading = false
        }
      },
    }
  }
</script>

<style scoped>

</style>
